<template>
  <div>
    <slot v-for="(option, index) in options" :item="option">
      <!-- fallback content here -->
      <button
        v-bind:key="index"
        type="button"
        class="btn btn-default"
        @click="changeSelectVal(option)"
        v-bind:class="['btn', selected === option ? 'btn-primary' : 'btn-dafault' ]"
      >{{ option }}</button>
    </slot>
  </div>
</template>

<script>
export default {
  name: "vue-toggle",
  props: ["options", "selected", "default"],
  ready: function() {
    this.selected = this.default;
  },
  methods: {
    changeSelectVal: function(option) {      
      var self = this;
      self.selected = option;
      self.$emit('update:selected', option)
    }
  }
};
</script>



